import styled from 'styled-components';
import tw from 'twin.macro';
import { FC } from 'react';
import Icon from './Icon';
import { IconColor, Icons } from '../enums';
import TooltipInfo from './TooltipInfo';
const CheckboxContainer = styled.div<{ $disabled?: boolean }>`
  ${tw`inline-flex items-start gap-1.5 cursor-pointer`}

  ${({ $disabled }) => $disabled && tw`pointer-events-none`}
`;

const CheckboxWrapper = styled.div`
  ${tw`relative flex items-center justify-center`}
`;

const StyledIcon = styled(Icon)`
  ${tw`absolute p-0.5 transition-opacity`}
`;

const HiddenInput = styled.input`
  ${tw`absolute w-full h-full top-0 opacity-0 z-10 cursor-pointer`}
`;

const StyledCheckbox = styled.div<{ $isChecked: boolean; $disabled?: boolean }>`
  ${tw`relative shrink-0 appearance-none w-5 h-5 border border-slate-400 rounded-lg bg-gradient-to-b from-white to-slate-100 flex items-center justify-center cursor-pointer`}

  ${({ $isChecked }) =>
    $isChecked ? tw`bg-primary from-emerald-600 to-primary border-0` : ''}
  
  ${({ $disabled }) => $disabled && tw`bg-slate-300`}

  &:focus {
    ${tw`ring-offset-0 ring-2 ring-slate-200 outline-none`}
  }

  &:disabled {
    ${tw`border-slate-400 bg-slate-400`}
  }
`;

const CheckboxLabel = styled.label<{ $disabled?: boolean }>`
  ${tw`pl-1 flex-1 text-xs text-slate-600 select-none cursor-pointer`}

  ${({ $disabled }) => $disabled && tw`text-slate-400 pointer-events-none`}
`;

interface Props {
  id: string;
  label?: string;
  isChecked: boolean;
  disabled?: boolean;
  className?: string;
  tooltip?: string;
  onToggle: (label: string) => void;
}

const Checkbox: FC<Props> = ({
  id,
  label,
  isChecked,
  disabled,
  className,
  tooltip,
  onToggle,
}) => (
  <TooltipInfo content={tooltip}>
    <CheckboxContainer className={className}>
      <CheckboxWrapper>
        <HiddenInput
          type="checkbox"
          id={id}
          checked={isChecked}
          onChange={() => onToggle(id)}
          disabled={disabled}
        />
        <StyledCheckbox $isChecked={isChecked} $disabled={disabled} />
        {isChecked && (
          <StyledIcon
            className="icon"
            icon={Icons.check}
            color={IconColor.white}
          />
        )}
      </CheckboxWrapper>
      {label && (
        <CheckboxLabel $disabled={disabled} htmlFor={id}>
          {label}
        </CheckboxLabel>
      )}
    </CheckboxContainer>
  </TooltipInfo>
);

export default Checkbox;
